import React from "react";
import { Text } from "@athena/ui";
import { Check } from "lucide-react";

interface StepperProps {
    current: number;
    completed: Set<number>;
    steps: string[];
}

export const Stepper: React.FC<StepperProps> = ({ current, completed, steps }) => {
    const STEPS = steps.map((label, i) => ({ n: i + 1, label }));

    return (
        <div className="flex items-center gap-0">
            {STEPS.map(({ n, label }, i) => {
                const isDone = completed.has(n);
                const isActive = current === n;
                return (
                    <React.Fragment key={n}>
                        <div className="flex items-center gap-2">
                            <div
                                className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold transition-colors ${
                                    isDone
                                        ? "bg-secondary text-white"
                                        : isActive
                                          ? "bg-foreground text-background"
                                          : "border-border text-muted-foreground border-2 bg-transparent"
                                }`}
                            >
                                {isDone ? <Check className="h-3.5 w-3.5" /> : String(n)}
                            </div>
                            <Text
                                className={`text-sm ${isActive ? "font-semibold" : "text-muted-foreground font-normal"}`}
                            >
                                {label}
                            </Text>
                        </div>
                        {i < STEPS.length - 1 && <div className="bg-border mx-3 h-px w-8 shrink-0" />}
                    </React.Fragment>
                );
            })}
        </div>
    );
};
